export default {"src":"/_next/static/media/visa.54d47209.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};